export const toqueColor = '#FE5000'
export const corporateColor = '#425563'
export const whiteBackgroundColor = '#EFEFEF'
export const darkLightColor = '#76777E'
export const disabledGray = '#A9A9A9'
export const transparentColor = 'rgba(1,1,1,.5)'
export const white = '#FFFFFF'
export const titleCardsColor = '#212E39'
export const grayBorders = '#D4D2D5'
export const lightBordersColor = 'rgb(246,245,245)'
export const selectedWhiteColor = '#FFFDFD'
export const inputTextColor = '#515C6F'
export const inputTextBackGround = 'rgb(241,240,241)'
export const inputTextPlaceholder = 'rgb(193,196,202)'
export const disabledSwitch = '#757575'
export const placeholderColor = '#ABA7AF'

export const dangerColor = '#DAAA00'
export const successColor = '#76881D'
export const successColorLight = '#A3C305'

export const textColor = '#425563'
export const lightBackground = '#F5F5F5'
export const lightBlue = '#859CAD'
export const greyBg = '#D9D9D9'

export const CENTERS_COLORS = {
  Activo: '#76881D',
  Vacío: '#FF0000',
}

export const NECROPSY_STATE = {
  sent: '#3DB542',
  pending: '#EF0808',
  sending: '#0872EF',
}
